import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useToast } from "../../view/components/ui/use-toast";
import { leadsService } from "../services/leadsService";
import { LeadParams } from "../services/leadsService/getLeads";

export const useGetLeads = ({ limit }: { limit: number }) => {
  const [params, setParams] = useState<LeadParams>({
    search: "",
    skip: 0,
    limit,
    sort: "createdAt",
    order: "-1",
  });

  const { toast } = useToast();

  const { data, isLoading, isFetching, isError, refetch } = useQuery({
    queryKey: ["AllLeads", params],
    queryFn: () => leadsService.getLeads(params),
    staleTime: 1000 * 5,
  });

  useEffect(() => {
    if (isError) {
      toast({
        variant: "destructive",
        title: "Erro ao carregar os leads, tente novamente mais tarde!",
      });
    }
  }, [isError, toast]);

  return {
    data,
    isLoading,
    isFetching,
    refetch,
    setParams,
    params,
  };
};
